module.exports = __webpack_public_path__ + "img/cereal.78843c20.png";